export interface SpotData {
  code: string;
  name: string;
  waterType: string;
  waterTypeSub: string;
  bestSeason: string;
  targetFish: string[];
  bestConditions: { flow: string; temp: string; clarity: string };
  beginnerTechnique: string;
  flyBox: { fly: string; size: string; type: string; note?: string }[];
  safetyNote: string;
  history: string;
  personalNotes: string;
  /** Public access point (Smelt Hill Dam area) — approximate, not a sensitive-water pin. */
  coordinates: { lat: number; lng: number };
}

export const SPOT: SpotData = {
  code: "PR-001",
  name: "Presumpscot River — Smelt Hill to Westbrook",
  coordinates: { lat: 43.7168, lng: -70.2478 },
  waterType: "River",
  waterTypeSub: "Tailwater · Freestone",
  bestSeason: "April – October",
  targetFish: [
    "Brown Trout (stocked + holdover)",
    "Brook Trout (upper tribs)",
    "Smallmouth Bass (lower)",
  ],
  bestConditions: {
    flow: "250–500 cfs",
    temp: "52–64°F",
    clarity: "Slight stain to clear",
  },
  beginnerTechnique:
    'Dead-drift nymphing under an indicator. Start with a #14 Pheasant Tail 18" below a 4mm putty indicator in the tailouts — the slower seams behind the riffles hold the most fish. Keep your drift drag-free; mend upstream the moment the indicator stalls.',
  flyBox: [
    { fly: "Pheasant Tail", size: "14–16", type: "Nymph" },
    { fly: "Hare's Ear", size: "14–16", type: "Nymph" },
    { fly: "Parachute Adams", size: "14–18", type: "Dry" },
    { fly: "Elk Hair Caddis", size: "14–16", type: "Dry" },
    { fly: "Woolly Bugger", size: "6–8", type: "Streamer", note: "Olive or white" },
  ],
  safetyNote:
    "The Smelt Hill dam tailrace can be hazardous. Wading conditions change quickly with generation releases — check the generation schedule before entering the water. The rocks below the dam are notoriously slick. Felt soles or studded wading boots strongly recommended.",
  history:
    "The Presumpscot was one of Maine's most dammed rivers — 13 dams over 23 miles — and its recovery is a conservation success story. The removal of the Smelt Hill dam in 2002 reopened 16 miles of river to sea-run fish for the first time in 200 years. Today the river is managed as a tailwater fishery, stocked annually with brown trout by MDIFW. The watershed drains 650 square miles of Cumberland and Oxford counties, and its tributaries hold remnant brook trout populations in the upper reaches. The river runs cold year-round thanks to the deep release from Sebago Lake, making it one of the most consistent fisheries in Southern Maine.",
  personalNotes:
    "The stretch below the 302 bridge fishes best in the morning before the canoe traffic starts. I've had my best days here in late May on a #16 Parachute Adams during a BWO hatch — the water was 54°F and crystal clear, and the browns were rising in every seam. Don't overlook the pocket water above the Westbrook flow: it looks too shallow but the holdover browns tuck into those buckets. One thing I wish I'd known earlier: the access just below the Smelt Hill boat launch is a gem — park at the turnaround, walk downstream 200yd, and you'll find a long glide that holds fish all summer.",
};

/** All known fishing spots — add new entries here to put them on the map. */
export const SPOTS: SpotData[] = [SPOT];
